import React from "react";
import "./App.css";
import "./index.css";

import { Route, Routes, useLocation } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import Privacy_Policy from "./components/privacy-policy/Privacy_Policy";
import Welcome_Video from "./components/welcome-video/Welcome_Video";
import Terms_Condition_User from "./components/terms-conditions-user/Terms_Condition_User";
import Login_Flow from "./components/login-flow/Login_Flow";
import Terms_Condition_Owner from "./components/terms-conditions-owner/Terms_Condition_Owner";
import ScrollToTop from "./components/scroll-to-top/ScrollToTop";

function App() {
  const location = useLocation();

  // Routes where Navbar should NOT appear
  const hideLayoutRoutes = ["/"];

  const hideLayout = hideLayoutRoutes.includes(location.pathname);

  return (
    <>
      <ScrollToTop />
      {!hideLayout && <Header />}
      <Routes>
        <Route path="/" element={<Welcome_Video />} />
        <Route path="/home" element={<Home />} />

        <Route path="/privacy-policy" element={<Privacy_Policy />} />
        <Route
          path="/terms-conditions-user"
          element={<Terms_Condition_User />}
        />
        <Route
          path="/terms-conditions-owner"
          element={<Terms_Condition_Owner />}
        />

        <Route path="/login-flow" element={<Login_Flow />} />
      </Routes>
      {!hideLayout && <Footer />}
    </>
  );
}

export default App;
